module.exports = __webpack_public_path__ + "static/media/Stuffed Animals.520eada9.png";